// extracted by mini-css-extract-plugin
module.exports = {"favoritesContainer":"_11ea5926","spacer":"_77425af0","loading":"_79901c80"};